import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga'
import { QueryClientProvider } from '@tanstack/react-query'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import 'bootstrap'
import 'trix/dist/trix.js'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { Capacitor } from '@capacitor/core'

/* Animations */
import 'animate.css'
import './assets/scss/custom.scss'
import 'trix/dist/trix.css'

import App from 'App'
import { store } from 'store/reducers'
import { lookupCompanyLang } from 'store/actions/auth'
import CapacitorService from 'services/Capacitor'
import { isProd } from 'services/Utilities'
import { initYupCustomMethods } from 'services/yup'
import { queryClient } from 'services/QueryClient'
// Init mobile app specific configuration
CapacitorService.init()

// Init Yup custom methods
initYupCustomMethods()

// Create a browser history handler
const history = createBrowserHistory()

// Tools to activate only in production
if (isProd) {
  datadogRum.init({
    allowedTracingUrls: [/https:\/\/(?!.?(rt|realtime)).*\.merinio\.com/],
    applicationId: '7dc2baf5-564d-4f07-9a9c-9f3a968d00d9',
    clientToken: 'pub44b4f81ed718c50bc861197c8a576388',
    defaultPrivacyLevel: 'allow',
    env: 'prod',
    sessionReplaySampleRate: Capacitor.isNativePlatform() ? 0 : 100,
    proxy: localStorage.getItem('ddProxyUrlOverride') ?? process.env.REACT_APP_DD_PROXY_URL,
    sessionSampleRate: 100,
    service: 'merinio-web-application',
    site: 'datadoghq.com',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    version: process.env.REACT_APP_CURRENT_VERSION
  })

  datadogLogs.init({ clientToken: 'pubd0ac9f4e68b0dfe60f3ad5457af94b3b', site: 'datadoghq.com', forwardErrorsToLogs: true, forwardConsoleLogs: 'all' })
  datadogRum.startSessionReplayRecording()

  // Init Google Analytics
  ReactGA.initialize('UA-87004221-5')

  // Adds a listener to track page changes
  history.listen(location => {
    ReactGA.ga('set', 'page', location.pathname)
    ReactGA.ga('send', 'pageview')
  })
}

// Lookup company name and default language
store.dispatch(lookupCompanyLang())

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <App />
      </QueryClientProvider>
    </Provider>
  </>
)
